import { render, staticRenderFns } from "./ChangeToBusinessPage.vue?vue&type=template&id=34c3df4d"
import script from "./ChangeToBusinessPage.vue?vue&type=script&lang=js"
export * from "./ChangeToBusinessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports